/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Card, Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { BsEyeFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import useToggle from "hooks/useToggle";
import useCheckRate from "hooks/hotel/useCheckRate";
import { square } from "ldrs";
import Policy from "component/Common/PolicyComponent";
square.register();

const CancellationModal = ({ hotel, rate }) => {
    const { isOpen, toggle } = useToggle();
    const [cancellationPolicies, setCancellationPolicies] = useState(null);
    const [comments, setComments] = useState(null); // TODO
    const { t } = useTranslation();
    const { checkRateCombined, checkRateNotCombined, isLoading, error } =
        useCheckRate(hotel);
    useEffect(() => {
        if (isOpen) {
            if (!hotel?.callCheckRates) return;
            if (hotel.combinedRooms) {
                checkRateCombined(rate.rateKey, true)
                    .then((res) => {
                        res?.comments && setComments(res.comments);
                        res?.cancellationPolicies &&
                            setCancellationPolicies(
                                res.cancellationPolicies?.cancellationPolicies
                            );
                    })
                    .catch((err) => console.log(err));
            } else {
                if (rate?.cancellationPolicies) {
                    setCancellationPolicies(rate.cancellationPolicies);
                } else {
                    checkRateNotCombined(rate.rateKey)
                        .then((res) => {
                            res?.comments && setComments(res.comments);
                            if (
                                res.rooms?.[0]?.rates?.[0]?.cancellationPolicies
                            ) {
                                setCancellationPolicies(
                                    res.rooms?.[0]?.rates?.[0]
                                        ?.cancellationPolicies
                                );
                            } else if (res?.cancellationPolicies) {
                                setCancellationPolicies(
                                    res.cancellationPolicies
                                        ?.cancellationPolicies
                                );
                            }
                        })
                        .catch((err) => console.log(err));
                }
            }
        }
    }, [isOpen, hotel]);

    return (
        <>
            <div className="d-flex justify-content-center justify-content-md-end">
                <div
                    onClick={toggle}
                    className=" flex flex-row items-center gap-2 s-link cursor-pointer"
                >
                    <BsEyeFill className="" />
                    <div className="">{t("cancellationPolicy")}</div>
                </div>
            </div>
            <Modal
                show={isOpen}
                onHide={toggle}
                size="lg"
                className="fade z-[9999999]"
                id="flightdetail"
                aria-hidden="true"
            >
                <ModalHeader className="d-flex justify-content-between  flex-row  w-100">
                    <div className="modal-title fs-5 fw-bold text-default">
                        {t("cancellationPolicy")}
                    </div>
                    <button
                        type="button"
                        className="btn-close m-0"
                        onClick={toggle}
                    />
                </ModalHeader>
                <ModalBody className="p-3">
                    <Card className="card-body rounded-0 p-2 room">
                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}
                        {comments && (
                            <div className="alert alert-info">{comments}</div>
                        )}
                        {!error && isLoading ? (
                            <div
                                className="w-100 d-flex justify-content-center align-items-center"
                                style={{ height: "60dvh" }}
                            >
                                <l-square
                                    size="40"
                                    stroke="3.5"
                                    speed="1"
                                    color="black"
                                ></l-square>
                            </div>
                        ) : (
                            <div>
                                <div className="">
                                    <div className="">
                                        <div
                                            className="mb-4"
                                            style={{
                                                fontWeight: "600",
                                                color: "var(--bs-solid)",
                                                fontSize: "1.1rem",
                                            }}
                                        >
                                            {rate.name}
                                        </div>
                                    </div>
                                    <div className="">
                                        {cancellationPolicies?.map(
                                            (policy, idx) => (
                                                <Policy
                                                    key={idx}
                                                    policy={policy}
                                                />
                                            )
                                        )}
                                    </div>

                                    <div className="p-2 border border-red-500 bg-red-200 rounded-md mt-4 ">
                                        <p className="w-full flex flex-row gap-2 items-center text-black">
                                            <span className="bg-red-500 text-white px-2 py-1 rounded-md">
                                                {t("important")}
                                            </span>
                                            {t("importantNote")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Card>
                </ModalBody>
            </Modal>
        </>
    );
};

export default CancellationModal;
